module.exports = new __parcel__URL__("magic-search.2ab41037.svg").toString();